import { render } from "./_icon-eye.vue?vue&type=template&id=b0fedeb2"
import script from "./_icon-eye.vue?vue&type=script&lang=js"
export * from "./_icon-eye.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__